import React from 'react';

export default function NoSearch(): JSX.Element {
  return (
    <div className="no-search">
      <p className="lead">
        Add a keyword or select a filter to start your search.
      </p>
    </div>
  );
}
